module.exports = __webpack_public_path__ + "assets/img/picture11.d052227d.svg";